import { Grid } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import React from 'react';
import ReactFlow from 'react-flow-renderer/nocss';
import { useDispatch, useSelector } from 'react-redux';
import { actions as graphActions } from '../../store/slices/v2Graph';
import {
    areAllNodesVisited,
    isEdge,
    processEdge,
    processNode,
} from '../../utils';
import ColorCodes from '../ColorCodes';

import CustomEdge from '../CustomEdge';
import CustomNode from '../CustomNode';

const V2Graph = () => {
    const dispatch = useDispatch();

    const elements = useSelector((state) => {
        const { nodes, edges } = state.v2Graph;
        return nodes.map(processNode).concat(edges.map(processEdge));
    });

    const allNodesVisited = useSelector((state) => {
        return areAllNodesVisited(state.v2Graph);
    });

    const handleElementClick = (event, element) => {
        if (isEdge(element)) {
            return;
        }
        dispatch(
            graphActions.select({
                nodeId: element.id,
            })
        );
    };

    return (
        <Grid className="grid-container" container>
            <Grid md={4}>
                <div className="content-container">
                    <p className="title">Objective</p>
                    <p>
                        Given a directed graph with non-negative weights, find
                        the shortest path from the source node to every node in
                        the graph.
                    </p>
                    <ColorCodes />

                    <p className="title">Setup</p>
                    <p>
                        You can click on any node to visit it, provided that all
                        its predecessors have been visited.
                    </p>
                    <p>
                        The system will annotate the selected node with the
                        length of the shortest path.
                    </p>
                    <p>
                        You can click on any visited node to set it as the
                        destination node and see the shortest path from the
                        source node.
                    </p>
                    <p>
                        If you select a node with unvisited predecessors, you
                        will see the corresponding error, and you must try
                        again.
                    </p>
                    <p className="title">Procedure</p>
                    <p>
                        Step 1: Select a node whose predecessors have been
                        visited to visit it.
                    </p>
                    <p>
                        Step 2: If all nodes have have been visited, the
                        shortest path algorithm using topological sort finishes.
                        Otherwise repeat step 1.
                    </p>
                </div>
            </Grid>
            <Grid md={8} className="graph-container">
                {allNodesVisited && (
                    <Alert severity="success" className="message">
                        All nodes have been visited
                    </Alert>
                )}
                <ReactFlow
                    zoomOnDoubleClick={false}
                    zoomOnScroll={false}
                    paneMoveable={false}
                    onLoad={(f) => f.fitView()}
                    onElementClick={handleElementClick}
                    elements={elements}
                    nodesDraggable={false}
                    nodesConnectable={false}
                    nodeTypes={{
                        customNode: CustomNode,
                    }}
                    edgeTypes={{
                        customEdge: CustomEdge,
                    }}
                />
            </Grid>
        </Grid>
    );
};

export default V2Graph;
